(function() {

    'use strict';
    angular.module('app')
        .controller('updateIntegrationCredentialsController', ['$scope', '$uibModalInstance', '$location', 'companyService','environment', updateIntegrationCredentialsController]);

    function updateIntegrationCredentialsController($scope, $uibModalInstance, $location, companyService, environment) {

        $scope.model = {};
        $scope.environment = environment;

        $scope.Close = function() {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.SaveCredentials = function() {

            companyService.updateIntegrationCredentials($scope.environment.id, $scope.model.username, $scope.model.password).then(function(response) {
                $uibModalInstance.close(true);
            });


          
        };
    }

})();
